module.exports = __webpack_public_path__ + "media/icons/eye-47ebd49d.svg";